import './index.scss';
import React from 'react';
import Version from './version';

const AppFooter = () => (

    <section className="app-footer">

        <div className="flex-container">
            <div>Copyright © 1996-2020 Deere&nbsp;&amp;&nbsp;Company, as an unpublished work.</div>
            <div>This is version <Version /> of the Warranty Warehouse System.</div>
            {/*<div>This is version 1.028 of the Warranty Warehouse System.</div>*/}

        </div>
        <div className="flex-container">
            <div>All Rights Reserved.</div>
        </div>

    </section>

);

AppFooter.displayName = 'AppFooter';

export default AppFooter;
